import "vanilla-cookieconsent/src/cookieconsent.js";

import initBurger from "./components/burger.js";
import initSlider from "./components/slider.js";
import initVideoplayers from "./components/videos.js";
import initIntroAnimation from "./components/intro.js";
import initMouse from "./components/mouse.js";
import initHeaderScroll from "./components/header.js";
import initLottieAnimations from './components/lottie.js';

window.addEventListener('DOMContentLoaded', () => {
  initBurger();
  initSlider();
  initVideoplayers();
  initHeaderScroll();
  initLottieAnimations();
});

window.addEventListener('load', () => {
  initIntroAnimation();
  initMouse();
});
